import * as reservation_types from "../../types/reservation_types";
import { PostRoute } from "../../../api";

const { Post } = PostRoute();

export const reserveVehicleInspectionSlot = (data) => async (dispatch) => {
  try {
    dispatch({ type: reservation_types.RESERVE_VEHICLE_REQUEST });

    const response = await Post("/reservations/reserve", data);

    if (response.status !== 201) {
      throw new Error(response.errors[0]);
    }

    dispatch({
      type: reservation_types.RESERVE_VEHICLE_SUCCESS,
      payload: "Slot reserved successfully",
    });

    return response.data;
  } catch (err) {
    dispatch({
      type: reservation_types.RESERVE_VEHICLE_ERROR,
      payload: err.response?.data?.errors?.[0] || err.message,
    });

    throw err;
  }
};
